<button>
    <span class="ss-size-14 ss-color-gunmetal ss-heebo" (click)="goBack()">
      <mat-icon svgIcon="ic-arrow-back" [ngStyle]="{'margin-right': marginRight}"></mat-icon>
      {{'GENERAL.goBack' | translate}}
    </span>
  </button>
